<script lang="ts">
    import { inview } from 'svelte-inview/dist/index';
    import { blur } from 'svelte/transition';
    import { onMount } from 'svelte';
    import { _ } from 'svelte-i18n';

    import { AssignmentJobApi } from '../AssignmentJobApi';
    import {
        debug,
        deliveryList,
        isMapLoaded,
        jobs,
        leftPageWidthPx,
        planning
    } from '../../../../stores/store';
    import { ApiFilterBuilder } from '@automapa/svelte-automapa-template';
    import MessageDanger from '../../../shared/Messages/MessageDanger.svelte';
    import MessageFoundItems from '../../../shared/MessageFoundItems.svelte';
    import TemplateRow from '../../../shared/TemplateRow.svelte';
    import AssignmentJobOne from './AssignmentJobOne.svelte';
    import MessageFiltered from '../../../shared/MessageFiltered.svelte';
    import { onMapReady } from '../../../utilities/onMapReady';
    import type { QueriesType } from '../../telematics/types';
    import Spinner from '../../../shared/Spinner/Spinner.svelte';
    import type { JobCountType } from '../../Jobs/types';
    import { PlanningOnMap } from '../PlanningOnMap';
    import { AssignmentApi, type EstimationRouteType } from '../AssignmentApi';
    import { api, clientSettings } from '../../../../stores/api';
    import { Assignment } from '../Assignment';
    import Switch from '../../../shared/Switch.svelte';
    import { get } from 'svelte/store';
    import SwitchView from '../../../shared/SwitchView.svelte';
    import { AssignmentJob } from '../AssignmentJob';
    import ErrorInline from '../../../shared/ErrorInline.svelte';
    import CalcRouteButton from '../CalcRouteButton.svelte';
    import { runOnlyWithStartPlanning } from '../StartPlanning';
    import { JobApi } from '../../Jobs/JobApi';
    import SelectRouteStartTime from './SelectRouteStartTime.svelte';
    import MessageInline from '../../../shared/Messages/MessageInline.svelte';
    import Separator from '../../../shared/Separator.svelte';
    import type { VehicleResponseType } from '../../Vehicles/types';
    import { VehiclesApi } from '../../Vehicles/VehiclesApi';
    import { openModal } from 'svelte-modals';
    import ModalConfirm from '../../../shared/Modals/ModalConfirm.svelte';
    import AssignmentJobOneHeader from './AssignmentJobOneHeader.svelte';
    import { getFilterAssignmentId } from '../getFilterAssignmentId';
    import ScenarioOneQuickCategories from '../QuickCategories/ScenarioOneQuickCategories.svelte';
    import { ScenarioApi } from '../ScenarioApi';
    import type { AssignmentResponseType } from '../AssignmentApi';
    import { MenuContextFactory } from '../../MenuDropdown/MenuContext/MenuContextFactory';
    import { MenuContextCustomActions } from '../../MenuDropdown/MenuContextCustomActions';
    import { RouteSummaryApp } from './RouteSummaryApp/RouteSummaryApp';
    import AssignmentRoutePointOne from './AssignmentRoutePointOne.svelte';
    import { type RoutePointExtendedType, RoutePointsApi } from '../../../utilities/RoutePointsApi';
    import { vehiclesManager } from '../../Vehicles/VehiclesApp/vehiclesManager';
    import { sortJobAssignments } from './sortJobAssignments';
    import { rsa } from './RouteSummaryApp/rsa';
    import { dla } from './DeliveryListApp/dla';
    import { DeliveriesBulkActions } from './DeliveriesBulkActions';
    import { DeliveriesMenuActions } from './DeliveriesMenuActions';
    import { features } from '../../../shared/Features/features';
    import { switchingBetweenTabsInProgress } from './store';
    import { setAssignmentJobMenu } from './assignmentjobmenu';

    export let queries: QueriesType = {};
    export let assignment: Assignment;
    export let onPolygonDraw: (geom: any) => void;
    export let makeBlured: boolean = false;
    export let totalCount: JobCountType = { count: 0 };
    export let filteredCount: JobCountType = { count: 0 };
    export let disabled: boolean;

    let loading: boolean = true;
    let loaded: boolean = false;
    let loadingAfterScroll: boolean = false;
    let error: string | { error: string; header: string; message: string } = '';
    // let filteredJobs: AssignmentJob[] = [];
    // let recentQueries = '';
    let filterChanged: boolean = false;

    const initialLimit = -1; //2000000;
    let jobFilter: ApiFilterBuilder = new ApiFilterBuilder(initialLimit);
    let limit: number = initialLimit;
    let offset: number = 0;
    let hasMore = true;
    let unassignedSection: Assignment;
    let suggestedAssignmentIds: number[] = [];
    let vehiclesAssignments: { id: number; vehicle_id: number }[] = [];
    let vehicles: VehicleResponseType[] = [];
    let scenarioAssignments: Assignment[] = [];

    let routePoints: RoutePointExtendedType[] = [];

    let suggestedCount: JobCountType = { count: 0 };
    let routingOnButtonClick = false;
    let componentMounted: boolean = false;
    let componentInitialized: boolean = false;

    // let disabledSwitches: boolean = false;
    let filterAssignment: QueriesType = {};

    let previousQuickCategoryId: string = '';

    let filteredItems: AssignmentJob[] = [];
    let allItemsCount: number = 0;
    let externalItems: boolean = false;

    let isAssignmentLocked: boolean = assignment.isLocked();

    function onFilterChange() {
        console.log('PlanningDeliveryList, onFilterChange');
        reloadElements();
    }

    function reloadElements(onInit: boolean = false) {
        // $deliveryList.triggerReload = false;
        console.log('reloadElements', assignment.getId(), $planning.selectedDay, queries);
        if (componentInitialized && assignment.getId() >= 0) {
            filterAssignment = getFilterAssignmentId(
                $dla.getShowSuggestedDeliveries(),
                $dla.getShowUnassignedDeliveries(),
                assignment.isDefault(),
                assignment.getId(),
                $planning.selectedDay
            );
            if (!loaded) {
                loading = true;
            }
            if (planningOnMap) {
                if (assignment.getId() > 0) {
                    planningOnMap.updateConfig({
                        queries,
                        assignmentTypes: {
                            unassigned: $dla.getShowUnassignedDeliveries(),
                            suggestions: $dla.getShowSuggestedDeliveries(),
                        },
                    });
                } else {
                    planningOnMap.updateConfig({ queries, assignmentQuery: filterAssignment });
                }
            }
            jobFilter.setRelations(['job*']);
            Promise.all([
                // $deliveryListManager.setQuery({ ...queries, ...filterAssignment }).load(),
                Promise.resolve(null), // TODO: instead of next reqeuest
                // AssignmentJobApi.getWithQueries( // TODO: remove this
                //     $api,
                //     { ...queries, ...filterAssignment },
                //     jobFilter
                // ),
                VehiclesApi.getAll($api),
                /*AssignmentJobApi.getSuggestedAssignmentIdsCount(
                    $api,
                    assignment.getId(),
                    $planning.selectedDay
                ),*/
                !loaded && !assignment.isDefault()
                    ? AssignmentApi.getByScenarioId($api, assignment.getScenarioId())
                    : null,
                assignment.isRouteCalculated()
                    ? RoutePointsApi.getPoints(get(api), assignment.getId())
                    : null,
                // AssignmentJobApi.getAllIds(get(api), assignment),
                !onInit ? $dla.populateFilteredIds(queries, jobFilter.getSortBy()) : null,
                AssignmentJobApi.getCountWithQueriesForAssignment($api, {
                    assignment_id: assignment.getId(),
                    unassigned: $dla.getShowUnassignedDeliveries(),
                    suggestions: $dla.getShowSuggestedDeliveries(),
                    only_in_realisation: $dla.getShowOnlyInRealisation(),
                    assignments: true,
                    day: $planning.selectedDay,
                    query: queries,
                })
            ])
                .then(response => {
                    console.log(
                        'PlanningDeliveryList..., assignment.getRouteInfo()',
                        assignment.getRouteInfo()
                    );
                    $deliveryList.triggerReload = false;
                    (async () => {
                        routePoints = response[3] ?? [];
                        $dla.setRoutePoints(routePoints);

                        $deliveryList.displayedAssignmentJobDetails = $dla
                            .getFilteredItems()
                            .map(aj => {
                                return {
                                    jobId: aj.getJobId(),
                                    hasAssignment: DeliveriesMenuActions.hasAssignment(aj),
                                    // hasSuggestion: aj.getSuggestedAssignmentId() === assignment.getId(),
                                    hasSuggestion: DeliveriesMenuActions.deliveryHasSuggestion(
                                        aj,
                                        assignment
                                    ),
                                    hasAdhoc: aj.isAdHoc(),
                                    canBeRejected: DeliveriesMenuActions.deliveryCanBeRejected(
                                        aj,
                                        assignment
                                    ),
                                    canBeAssigned: DeliveriesMenuActions.deliveryCanBeAssigned(
                                        aj,
                                        assignment
                                    ),
                                };
                            });
                        hasMore = false; // response[0].length !== 0;
                        offset = 0;
                        if (response[5] !== null) {
                            filteredCount = { count: response[5].all.filtered };
                            totalCount = { count: response[5].all.total };
                            suggestedCount = { count: response[5].suggestions?.filtered || 0 };
                            $deliveryList.countAssignedFiltered = {
                                count: response[5].assignments?.filtered || 0,
                            };
                        }
                        $deliveryList.countFiltered.count = filteredCount.count;
                        $deliveryList.queryFilter = { ...filterAssignment };
                        vehicles = response[1];
                        if (!loaded) {
                            scenarioAssignments = response[2]
                                ? response[2].map(a => new Assignment(a))
                                : [];
                            vehiclesAssignments = response[2]
                                ? response[2]
                                      .filter(a => a.vehicle_id)
                                      .map(a => {
                                          return { id: a.id, vehicle_id: a.vehicle_id || 0 };
                                      })
                                : [
                                      {
                                          id: assignment.getId(),
                                          vehicle_id: assignment.getVehicleId() || 0,
                                      },
                                  ];
                            loaded = true;
                            loading = false;
                        }
                        loading = false;
                        loadingAfterScroll = false;
                        // disabledSwitches = false;
                        $switchingBetweenTabsInProgress = false;
                    })();
                })
                .catch(err => {
                    error = err;
                    console.error('PlanningDeliveryList, reloadElements, error', err);
                    // disabledSwitches = false;
                    loading = false;
                }).finally(() => {
                    console.log('PlanningDeliveryList, reloadElements, finally');
                    let fItems = $dla.getFilteredItems(true);
                    allItemsCount = fItems.length;
                    if (allItemsCount > 50) {
                        filteredItems = fItems.slice(0, 30);
                    } else {
                        filteredItems = fItems;
                    }
                    $switchingBetweenTabsInProgress = false;
                });
        } else {
            console.log(
                'PlanningDeliveryList, reloadElements, componentInitialized',
                componentInitialized
            );
            // disabledSwitches = true;
            $switchingBetweenTabsInProgress = false;
            loading = false;
        }
    }

    let planningOnMap: PlanningOnMap;
    let leaveMapObjects: boolean = false;

    function refreshAssignment() {
        if (assignment.isDefault()) {
            let route_info = assignment.getRouteInfo();
            if (route_info && route_info.route && !route_info.route.inprogress) {
                route_info.progress = null;
                route_info.route.inprogress = true;
                route_info.stage = 'routing';
                assignment.setRouteInfo(route_info);
                assignment = assignment;
            }
            AssignmentApi.getOneWithCounters(
                get(api),
                assignment.getId() > 0 ? assignment.getId() : $planning.selectedDay
            ).then(response => {
                if (!response.scenario_id) {
                    response.scenario_id = assignment.getScenarioId();
                }
                assignment.set(response);
                assignment = assignment;
                if (assignment.isRouteInCalculation()) {
                    setTimeout(refreshAssignment, 1000 + Math.random() * 500);
                } else if (assignment.canRouteBeCalculated() && !assignment.isRouteCalculated()) {
                    $rsa = $rsa.startLoading();
                    $rsa.reload(assignment)
                        .then(ass => {
                            assignment = ass;
                        })
                        .catch(err => console.error('Cannot load estimate for some route'))
                        .finally(() => {
                            $rsa = $rsa.stopLoading();
                        });
                }
            });
        } else if (assignment.isAdHoc()) {
            ScenarioApi.getAdHocAssignment(get(api), assignment.getScenarioId()).then(
                (response: AssignmentResponseType) => {
                    if (response && response.details) {
                        assignment.updateRealisationStatus(response); // FIXME: types
                        assignment.updateQuickCategories();
                        assignment = assignment;
                    }
                }
            );
        }
    }


    function onRouteSelect(
        jobId: number,
        suggestion: boolean,
        newAssignmentId: number | null,
        newAssignment: Assignment | null | undefined
    ): Promise<boolean> {
        console.log('onRouteSelect', jobId, suggestion, newAssignmentId, newAssignment);
        return new Promise<boolean>((resolve, reject) => {
            if (newAssignmentId && newAssignment) {
                console.log('onRouteSelect', newAssignment.isLocked());
                if (newAssignment.isLocked()) {
                    let confirm: { title: string; message: string };
                    if (newAssignment.isDownloaded()) {
                        confirm = {
                            title: $_('route_already_downloaded'),
                            message: $_('new_jobs_will_be_added_on_commit_subject_to_approval'),
                        };
                    } else {
                        confirm = {
                            title: $_('route_already_locked'),
                            message: $_('adding_jobs_unlocks_route'),
                        };
                    }
                    console.log('onRouteSelect', confirm.title, confirm.message);
                    openModal(ModalConfirm, {
                        title: confirm.title,
                        text: confirm.message,
                        onClick: async () => {
                            newAssignment.setLocked(false);
                            await DeliveriesBulkActions.doAssign(
                                get(api),
                                newAssignmentId,
                                [jobId],
                                'selected',
                                {},
                                get(planning).selectedDay
                            );
                            onFilterChange();
                            return Promise.resolve(true);
                        },
                        onCancel: () => {
                            resolve(false);
                        },
                    });
                    return;
                } else {
                    console.log(
                        'onRouteSelect',
                        'reassignJob',
                        jobId,
                        newAssignmentId,
                        null,
                        suggestion
                    );
                    // reassignJob(jobId, newAssignmentId, null, suggestion);
                    // reassignJob(jobId, newAssignmentId, null, true, () => {
                    //     resolve(true);
                    // });
                    DeliveriesBulkActions.doAssign(
                        get(api),
                        newAssignmentId,
                        [jobId],
                        'selected',
                        {},
                        get(planning).selectedDay
                    ).then(() => {
                        onFilterChange();
                        resolve(true);
                    });
                }
            } else {
                console.error('onRouteSelect', 'newAssignmentId or newAssignment is null');
                resolve(false);
            }
        });
    }

    function onJobClick(evt: any) {
        console.log('planningOnMap, clicked point on map', evt);
        $deliveryList.expandedIndex = [evt.detail.jobId];
        let item = $dla
            .getItems()
            .find(
                (item: AssignmentJob) =>
                    item.getJobId() == evt.detail.jobId/* &&
                    item.getMenu().getVisibleActions().length > 0*/
            );
        if (item) {
            if (!assignment.isLocked()) {
                let menu = item.getMenu();
                if (!menu || !menu.isValid()) {
                    let actionHandler = function(action: string, end: boolean, aj: AssignmentJob) {
                        if (end) {
                            if (['select_another_assignment', 'reject', 'assign_to_last_used'].includes(action)) {
                                if (action != 'assign_to_last_used' || assignment.getId() !== item.getAssignmentId()) {
                                    onFilterChange();
                                }
                            }
                        }
                    }
                    item = setAssignmentJobMenu(item, assignment, actionHandler);
                    menu = item.getMenu();
                }
                if (menu?.getVisibleActions().length > 0) {
                    console.log(
                        'planningOnMap, menu exists, actions: ',
                        menu.getActions().length
                    );
                    MenuContextFactory.set(menu);
                    MenuContextFactory.setCoords(
                        evt.detail.page[0],
                        evt.detail.page[1]
                    );
                    MenuContextFactory.open();
                }
            }
        } else {
            console.warn(
                'planningOnMap, clicked point on map, no menu for jobId',
                evt.detail.jobId
            );
        }
    }

    function onJobSelect(evt: any) {
        let jobId = evt.detail.jobId;
        let selection = evt.detail.selection;
        if ($deliveryList.selectMode === 'selected') {
            $deliveryList.selectedOrUnselected = selection;
        } else {
            $deliveryList.selectedOrUnselected = $dla.getFilteredJobIds().filter((e) => !selection.includes(e));
        }
        console.log('onJobSelect', jobId, selection, $deliveryList.selectMode, $deliveryList.selectedOrUnselected);
        if (selection.length == 1 && selection[0] == jobId) {
            onJobClick(evt);
        }
        $deliveryList = $deliveryList;
    }

    onMount(() => {
        console.log('PlanningDeliveryList, onMount');
        // jobFilter.sortBy(['id', 'job_id'], ['asc', 'asc']);
        jobFilter.sortBy(
            ['job.computed_address.city', 'job.computed_address.street_for_sorting', 'job.computed_address.house_as_number::int', 'job.computed_address.house'],
            ['asc', 'asc', 'asc', 'asc']
        );
        componentMounted = true;
        loading = true;
        error = '';
        console.log('PlanningDeliveryList, onMount 2');
        Promise.all([
            null, //AssignmentApi.getUnassignedAsList(get(api), $planning.selectedDay, ['jobs']),
            0 && assignment.getId() > 0
                ? AssignmentJobApi.getSuggestedAssignmentIdsCount(
                      // FIXME: long time (12s)
                      $api,
                      assignment.getId(),
                      $planning.selectedDay
                  )
                : null,
            onMapReady(),
            $vehiclesManager.prepareData(),
        ])
            .then(response => {
                console.log('PlanningDeliveryList, then');
                if (response[0]) {
                    unassignedSection = new Assignment(response[0]);
                    loading = false;
                } else {
                    //no need to load this pseudoassignment, it's easier to create it
                    unassignedSection = new Assignment({
                        id: 0,
                        scenario_id: assignment.getScenarioId(),
                        type: 'unset',
                        name: 'unset',
                        zone_id: null,
                        vehicle_id: null,
                        committed: false,
                        updated: '',
                        created: '',
                        route_info: {},
                    });
                    /*error =
                        'Ten scenariusz nie ma assignmentu dla zleceń nieprzypisanych (missing <unset> assignment).';*/
                    loading = false;
                }
                suggestedCount = assignment.isDefault() && response[1] ? response[1] : { count: 0 };
                componentInitialized = true;

                reloadElements(true);

                if (componentMounted) {
                    let planningOnMapConfig = {
                        queries: queries,
                        scenarioId: assignment.getScenarioId(),
                        date: $planning.selectedDay,
                        selectedAssignment: assignment,
                        showRoute: false,
                        selectJobs: $features.feature_ux_improvements && !assignment.isLocked(),
                        assignOptions: { assign: $_('Assign to'), unassign: $_('Remove') },
                    };
                    if (assignment.getId() > 0) {
                        planningOnMapConfig.assignmentTypes = {
                            unassigned: $dla.getShowUnassignedDeliveries(),
                            suggestions: $dla.getShowSuggestedDeliveries(),
                        };
                    } else {
                        planningOnMapConfig.assignmentQuery = getFilterAssignmentId(
                            $dla.getShowSuggestedDeliveries(),
                            $dla.getShowUnassignedDeliveries(),
                            assignment.isDefault(),
                            assignment.getId(),
                            $planning.selectedDay
                        );
                    }
                    planningOnMap = new PlanningOnMap(planningOnMapConfig);
                    //planningOnMap.zoomToAssignment(getFilterAssignmentId($planning.showSuggestedDeliveries, $planning.showUnassignedDeliveries));
                    if ($clientSettings.display.zoom_map_on_every_change) {
                        planningOnMap.zoomBestFit(true);
                    }
                    planningOnMap.addEventListener('jobclick', onJobClick);
                    planningOnMap.addEventListener('jobrightclick', onJobClick);
                    planningOnMap.addEventListener('jobselect', onJobSelect);
                    planningOnMap.addEventListener('jobdrag', function (evt: any) {
                        if (evt.detail.target) {
                            let data = {
                                query: {
                                    job_id: { $in: evt.detail.jobs.map((j: any) => j.jobId) },
                                },
                                assignment_id: evt.detail.target,
                            };
                            AssignmentJobApi.changeAssignments(get(api), data)
                                .then(res => {
                                    console.log('res', res);
                                    reloadElements();
                                })
                                .catch(err => {
                                    console.error('err', err);
                                })
                                .finally(() => {
                                    console.log('finally');
                                });
                        }
                    });
                    planningOnMap.addEventListener('filterset', (evt: any) => {
                        if (filterChanged) {
                            filterChanged = false;
                            if ($clientSettings.display.zoom_map_on_every_change) {
                                planningOnMap.zoomBestFit(true);
                            }
                        }
                    });
                    $dla.setMapModule(planningOnMap);
                }
            })
            .catch(err => {
                console.error('PlanningDeliveryList, onMount, error', err);
                error = $_('fetch_deliveries_failed');
                loading = false;
            });

        return () => {
            componentMounted = false;
            if (planningOnMap) {
                planningOnMap.destroy(leaveMapObjects);
                $dla.setMapModule(null);
            }
        };
    });

    // $: {
    //     console.log('PlanningDeliveryList, queries', queries);
    //     // queries = queries;
    //     if (JSON.stringify(queries) !== recentQueries) {
    //         recentQueries = JSON.stringify(queries);
    //         filterChanged = true;
    //         reloadElements();
    //     }
    // }

    $: {
        // $planning.showUnassignedDeliveries = $planning.showUnassignedDeliveries;
        // $planning.showSuggestedDeliveries = $planning.showSuggestedDeliveries;
        $planning.currentQuickCategoryId = $planning.currentQuickCategoryId;
        if ($planning.currentQuickCategoryId != previousQuickCategoryId) {
            previousQuickCategoryId = $planning.currentQuickCategoryId;
            filterChanged = true;
            // $filteredJobs = [];
            loadingAfterScroll = true;
            reloadElements();
        }
    }

    // $: {
    //     $filteredJobs = $filteredJobs;
    // }

    $: {
        console.log(
            '_reload, PlanningDeliveryList, $deliveryList.triggerReload, isLocked',
            $deliveryList.triggerReload,
            assignment.isLocked()
        );
        if ($deliveryList.triggerReload) {
            console.log('_reload, reloadElements', $deliveryList.triggerReload);
            $deliveryList.triggerReload = false;
            reloadElements();
        }
    }

    $: {
        if (planningOnMap) {
            let selection;
            if ($deliveryList.selectMode === 'selected') {
                selection = $deliveryList.selectedOrUnselected;
            } else {
                selection = $dla.getFilteredJobIds().filter(j => !$deliveryList.selectedOrUnselected.includes(j));
            }
            console.log('PlanningDeliveryList, jobSetSelection', selection);
            planningOnMap.jobSetSelection(selection);
        }
    }

    let minimizeViewTimeWindow: boolean = $leftPageWidthPx<600;
    $: minimizeViewTimeWindow = $leftPageWidthPx<600;

    $: disabled = disabled;

    $: {
        let allItems = $dla.getFilteredItems(true);
        allItemsCount = allItems.length;
        filteredItems = allItems.slice(0, filteredItems.length);
    }

    $: {
        if (assignment.isLocked() != isAssignmentLocked) {
            isAssignmentLocked = assignment.isLocked();
            if (planningOnMap && $features.feature_ux_improvements) {
                planningOnMap.updateConfig({selectJobs: !isAssignmentLocked});
            }
        }
    }

    $: {
        if ($dla.externalItems != externalItems && planningOnMap) {
            externalItems = $dla.externalItems;
            if (externalItems) {
                filteredItems = $dla.getFilteredItems(true);
                allItemsCount = filteredItems.length;
                planningOnMap.updateConfig({externalJobs: filteredItems.map(aj => aj.assignmentJob)});
            }
        }
    }

</script>

{#if loading}
    <div style="min-height: 100px;">
        <Spinner />
    </div>
{:else}
    {#if error}
        {#if typeof error == 'string'}
            <MessageDanger {error} />
        {:else}
            <MessageDanger error={error.error} header={error.header} message={error.message} />
        {/if}
    {/if}

    {#if assignment.isAdHoc()}
        <div style="margin: 22px 0 17px 0;">
            <ScenarioOneQuickCategories assignments={[assignment]} />
        </div>
    {/if}

    {#if $debug}
        <div>disabled={disabled}</div>
    {/if}

    <div style="padding-right:15px; margin-top: 15px;">
        <AssignmentJobOneHeader bind:assignment bind:jobFilter {onFilterChange} {minimizeViewTimeWindow} {disabled}/>
    </div>
    <div class="project-list" style="display: flex; flex-direction: column; overflow-y: hidden;">
        <div class="job-list" class:minimizeViewTimeWindow>
            {#each filteredItems as assignmentJob (assignmentJob.getJobId())}
                <div>
                    <AssignmentJobOne
                        {disabled}
                        simpleView={true}
                        bind:assignmentJob
                        bind:assignment
                        {unassignedSection}
                        showHeader={false}
                        {onFilterChange}
                        {onRouteSelect}
                        {planningOnMap}
                        bind:vehiclesAssignments
                        bind:vehicles
                        allAssignments={scenarioAssignments}
                        bind:expandedIndex={$deliveryList.expandedIndex}
                        {minimizeViewTimeWindow}
                    />
                </div>
            {:else}
                <MessageFoundItems count={$dla.getFilteredItems().length} />
            {/each}
            {#if allItemsCount > filteredItems.length}
                <div use:inview="{{}}" on:inview_enter="{(e) => {
                    if (e.detail.inView) {
                        filteredItems = filteredItems.concat($dla.getFilteredItems(true).slice(filteredItems.length, filteredItems.length + 50));
                    }
                }}">
                    <Spinner/>
                </div>
            {/if}
        </div>
    </div>
{/if}

<style>
    .project-list {
        overflow-y: auto;
        overflow-x: hidden;
        flex: 1;
        /*padding: 20px 0;*/
    }
    .job-list {
        display: flex;
        flex-direction: column;
        overflow-y: auto;
        overflow-x: hidden;
        flex: 1;
        padding-bottom: 40px;
        margin-bottom: 20px;
        padding-right: 15px;
    }
    /*             style="display: flex; flex-direction: column; overflow-y: auto; flex: 1 0 105%; overflow-x: hidden;"*/
</style>
